import { Box, FormControl, InputLabel, MenuItem, Select, Checkbox } from "@mui/material";

interface DropDownProps {
    label: string,
    selectedValue: any,
    onSelection: (value: any) => void,
    items: any,
    keyProp?: string,
    valueProp?: string,
    displayProp?: string,
    multiple?: boolean,
    disabled?: boolean,
    required?: boolean,
    style?: { [key: string]: any };
    height?: number | string;
    minWidth?: number | string;
}

const DropDown: React.FC<DropDownProps> = ({ label, selectedValue, onSelection, items, keyProp, valueProp, displayProp, multiple, disabled, required, style, height, minWidth }) => {

    return (
        <Box width="100%" sx={{ ...style, mt: 2 }}>
            <FormControl fullWidth  disabled={disabled}>
                <InputLabel >{label}</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    label={label}
                    multiple={multiple ? true : false}
                    value={selectedValue}
                    required={required}
                    onChange={(event) => onSelection(event.target.value)}
                    sx={{ 
                        ...(height && { height }), 
                        ...(minWidth && { minWidth }) 
                    }}
                >
                    {items?.map((item: any) => (
                        <MenuItem key={keyProp ? item[keyProp] : item} value={valueProp ? item[valueProp] : item}>
                            {multiple && (
                                <Checkbox
                                    checked={selectedValue.indexOf(valueProp ? item[valueProp] : item) > -1}
                                />
                            )}
                            {displayProp ? item[displayProp] : item}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}

export default DropDown;